const searchBasePath = '/search';

const getSearchQueryLink = (input: string) => {
  return `${searchBasePath}${input ? `?q=${encodeURIComponent(input)}` : ''}`;
};

export default getSearchQueryLink;
